define(function(){

    'use strict';

    return {

        fabri : false
    }

});


//////////////////
// WEBPACK FOOTER
// ./src/config/data-editor.js
// module id = 66
// module chunks = 0